import { useState } from "react";
import api from "../../api";

export interface LeadType {
    id: string;
    name: string;
    email?: string;
    phone?: string;
}

export interface LeadFilter {
    name?: string;
    email?: string;
    pageNumber?: number;
    pageSize?: number;
}

export default function useLead() {
    const [leads, setLeads] = useState<LeadType[]>([]);

    async function getAllLeads(): Promise<LeadType[] | null> {
        try {
            const { data } = await api.get("/lead/all");
            if (data.isSuccess) {
                setLeads(data.data);
                return data.data;
            }
            return null;
        } catch (error) {
            console.error("Erro ao buscar todos os leads:", error);
            return null;
        }
    }

    async function getLeads(filter?: LeadFilter): Promise<LeadType[] | null> {
        try {
            const { data } = await api.get("/lead", { params: filter });
            if (data.isSuccess) {
                setLeads(data.data);
                return data.data;
            }
            return null;
        } catch (error) {
            console.error("Erro ao buscar leads com filtro:", error);
            return null;
        }
    }

    async function createLead(payload: {
        name: string;
        email?: string;
        phone?: string;
    }): Promise<LeadType | null> {
        try {
            const { data } = await api.post("/lead", payload);
            if (data.isSuccess) {
                setLeads((prev) => [...prev, data.data]);
                return data.data;
            }
            return null;
        } catch (error) {
            console.error("Erro ao criar lead:", error);
            return null;
        }
    }

    return {
        leads,
        setLeads,
        getAllLeads,
        getLeads,
        createLead,
    };
}